import React, { ComponentType, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { currentUser } from 'redux/session/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { FullHeaderLeftSideFullPanelLayout } from 'layouts/fullHeader.LeftSideFullPanel.layout';
import SafetyMessageAndLogoForm from './components/forms';
import { withFormik } from 'formik';
import { SafetyMessageAndLogoDataType } from 'types';
import { updateSafetyMessageAndLogoStart } from 'redux/safetyMessageAndLogo/actions';
import { SafetyMessageAndLogoSchema } from 'utilities/validation/safetyMessageAndLogo.validation.schema';

interface InitialFormValuesProps {
  safetyMessage: string;
  logo: any;
  isDelete: boolean;
}

const SafetyMessageAndLogo: React.FC<
  RouteComponentProps<{}, any, any>
> = () => {
  const dispatch = useDispatch();
  const user: any = useSelector(currentUser);
  const [organisationId, setOrganisationId] = useState<any>();
  const [formValues, setFormValues] = useState<SafetyMessageAndLogoDataType>({
    safetyMessage: '',
    logo: undefined
  });

  useEffect(() => {
    if (user) {
      const { organisationId, Organisation } = user;

      const { safetyMessage, LogoImageFile: logo } = Organisation;
      setOrganisationId(organisationId);
      setFormValues({
        safetyMessage,
        logo
      });
    }
  }, [user]);

  const SafetyMessageAndLogoFormComp: ComponentType<any> = withFormik<
    InitialFormValuesProps,
    SafetyMessageAndLogoDataType
  >({
    validationSchema: SafetyMessageAndLogoSchema,
    mapPropsToValues: () => ({
      safetyMessage: formValues?.safetyMessage || '',
      logo: formValues?.logo || undefined
    }),
    handleSubmit: (values: SafetyMessageAndLogoDataType) => {
      const { safetyMessage, logo, isDelete } = values;
      const payload: SafetyMessageAndLogoDataType = {
        safetyMessage,
        logo,
        isDelete
      };
      const params = { organisationId, payload };
      setFormValues({
        safetyMessage,
        logo,
        isDelete
      });
      // later add dispatch safetyMessage
      dispatch(updateSafetyMessageAndLogoStart(params));
    },
    displayName: 'RegConfirmationForm'
  })(SafetyMessageAndLogoForm);

  return (
    <div id="safety-message-and-logo" data-testid="safety-message-and-logo">
      <FullHeaderLeftSideFullPanelLayout
        pageHeading="Safety message and logo"
        enableHeaderGlobalBar={true}
      >
        <div className="safety-message-and-logo--body">
          <SafetyMessageAndLogoFormComp displayName="SafetyMessageAndLogoForm" />
        </div>
      </FullHeaderLeftSideFullPanelLayout>
    </div>
  );
};
SafetyMessageAndLogo.displayName = 'SafetyMessageAndLogoModule';

export default SafetyMessageAndLogo;
